<template>
  <NxInput
    name="numero"
    type="text"
    label="Número:"
    placeholder="EX: 3325"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputEnderecoNumero',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputEnderecoNumero.vue